import {
  UPLOAD_MEDIA_REQUESTED,
  UPLOAD_MEDIA_SUCCEED,
  UPLOAD_MEDIA_FAILED,
} from './constants';

export function uploadMediaItems(key, files) {
  return {
    type: UPLOAD_MEDIA_REQUESTED,
    payload: {
      key,
      files,
    },
  };
}

export function uploadMediaItemsSucceed(key, response) {
  return {
    type: UPLOAD_MEDIA_SUCCEED,
    payload: {
      key,
      response,
    },
  };
}

export function uploadMediaItemsFailed(key, errors) {
  return {
    type: UPLOAD_MEDIA_FAILED,
    payload: {
      key,
      errors,
    },
  };
}
